import { render } from "./MetricCard.vue?vue&type=template&id=270bc98b&scoped=true"
import script from "./MetricCard.vue?vue&type=script&lang=js"
export * from "./MetricCard.vue?vue&type=script&lang=js"

import "./MetricCard.vue?vue&type=style&index=0&id=270bc98b&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270bc98b"],['__file',"resources/js/components/MetricCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "270bc98b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('270bc98b', __exports__)) {
    api.reload('270bc98b', __exports__)
  }
  
  module.hot.accept("./MetricCard.vue?vue&type=template&id=270bc98b&scoped=true", () => {
    api.rerender('270bc98b', render)
  })

}


export default __exports__